import { render, staticRenderFns } from "./FunctionCard.vue?vue&type=template&id=0b95be8e&scoped=true"
import script from "./FunctionCard.vue?vue&type=script&lang=js"
export * from "./FunctionCard.vue?vue&type=script&lang=js"
import style0 from "./FunctionCard.vue?vue&type=style&index=0&id=0b95be8e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b95be8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b95be8e')) {
      api.createRecord('0b95be8e', component.options)
    } else {
      api.reload('0b95be8e', component.options)
    }
    module.hot.accept("./FunctionCard.vue?vue&type=template&id=0b95be8e&scoped=true", function () {
      api.rerender('0b95be8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/OutboundCallingBot/components/FunctionCard.vue"
export default component.exports